import React, { useEffect, useState } from "react";
import { useWebApp, WebAppProvider } from "@vkruglikov/react-telegram-web-app";
import "./App.css";
import PaymentForm from "./components/PaymentForm";
import PrePayment from "./components/PrePayment";
import { STRINGS_EN, STRINGS_RU } from "./localization";
import { getPaymentViewData } from "./services/paymentService";
import Sticker from "./components/Sticker";
import mixpanel from "mixpanel-browser";

function AppContent() {
  const webApp = useWebApp();
  const urlParams = new URLSearchParams(window.location.search);
  const urlLang = urlParams.get("lang");
  const user_id = webApp.initDataUnsafe?.user?.id || urlParams.get("user_id");
  const [isLoading, setIsLoading] = useState(true);
  const [paymentData, setPaymentData] = useState({});
  const [showPaymentForm, setShowPaymentForm] = useState(false);

  const isLocalhost = window.location.hostname === "localhost";
  if (isLocalhost) {
    mixpanel.init("088fd0374a72277a49c3501906caab1c");
  } else {
    mixpanel.init("4acbbf84b424e3265bcc39e82cb3634b");
  }

  mixpanel.identify(user_id);

  mixpanel.track("Payment webapp opened");

  const language =
    urlLang || webApp.initDataUnsafe?.user?.language_code || "en";
  const STRINGS = language === "ru" ? STRINGS_RU : STRINGS_EN;

  useEffect(() => {
    webApp.ready();
    webApp.expand();
    webApp.disableVerticalSwipes();

    const fetchData = async () => {
      try {
        if (user_id) {
          const fetchedPaymentData = await getPaymentViewData(user_id);
          setPaymentData(fetchedPaymentData);
        }
      } catch (err) {
        console.error("Error fetching data:", err);
        mixpanel.track("Error", {
          info: "Payment webapp failed getPaymentViewData",
          error: JSON.stringify(err),
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [webApp, user_id]);

  if (isLoading) {
    return (
      <div className="payment-container center-content">
        <Sticker type="loading" size={180} />
      </div>
    );
  }

  return (
    <div className="App">
      {Object.keys(paymentData).length > 0 &&
        (!paymentData.subscription?.active && !showPaymentForm ? (
          <PrePayment
            strings={STRINGS}
            language={language}
            mixpanel={mixpanel}
            setShowPaymentForm={setShowPaymentForm}
          />
        ) : (
          <PaymentForm
            strings={STRINGS}
            language={language}
            user_id={user_id}
            paymentData={paymentData}
          />
        ))}
    </div>
  );
}

function App() {
  return (
    <WebAppProvider>
      <AppContent />
    </WebAppProvider>
  );
}

export default App;
